import AsyncRecorder from './AsyncRecorder';
import { RecorderEvent } from './Recorder';
import { VIDEO_FPS } from '../data/Config';

export class H264AsyncRecorder extends AsyncRecorder {
  encoder: any;
  offscreenCanvas: HTMLCanvasElement;
  offscreenContext: CanvasRenderingContext2D;

  constructor(
    canvas: HTMLCanvasElement,
    framesNumber: number,
    duration: number
  ) {
    super(canvas, framesNumber, duration, null, null);

    this.offscreenCanvas = document.createElement('canvas');
    this.offscreenCanvas.width = canvas.width;
    this.offscreenCanvas.height = canvas.height;
    this.offscreenContext = this.offscreenCanvas.getContext('2d')!;
  }

  async createEncoder() {
    const HME = (window as any).HME;
    if (!HME) {
      throw new Error('h264-mp4-encoder is not available');
    }
    this.encoder = await HME.createH264MP4Encoder();
    this.encoder.width = this.canvas.width;
    this.encoder.height = this.canvas.height;
    this.encoder.frameRate = VIDEO_FPS;
    this.encoder.kbps = 20000;
    this.encoder.initialize();
  }

  update() {
    if (this._currentFrame === this.framesNumber) {
      return;
    }
    this.offscreenContext.drawImage(this.canvas, 0, 0);
    this.encoder.addFrameRgba(
      this.offscreenContext.getImageData(
        0,
        0,
        this.canvas.width,
        this.canvas.height
      ).data
    );
    this._currentFrame++;
    if (this._currentFrame === this.framesNumber) {
      this.emit(RecorderEvent.RecordingEnded);
      this.encoder.finalize();
      const uint8Array = this.encoder.FS.readFile(this.encoder.outputFilename);
      const blob = new Blob([uint8Array], { type: 'video/mp4' });
      const url = URL.createObjectURL(blob);
      this.encoder.delete();
      this.emit(RecorderEvent.Complete, url);
    }
  }

  cancel() {
    super.cancel();
    if (this.encoder) {
      this.encoder.finalize();
      this.encoder.delete();
    }
  }
}



// WEBPACK FOOTER //
// ./src/video/H264AsyncRecorder.ts